import { render } from "./AuthFromAnother.vue?vue&type=template&id=2b209c7b&scoped=true"
import script from "./AuthFromAnother.vue?vue&type=script&lang=js"
export * from "./AuthFromAnother.vue?vue&type=script&lang=js"

import "./AuthFromAnother.vue?vue&type=style&index=0&id=2b209c7b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b209c7b"]])

export default __exports__